import React, { Component, PropTypes } from 'react'

/* Styles */
import './index.css'


/* Single Playlist List Item */
export default class InfoText extends Component {

    constructor(props) {
        super(props)
    }

    getClassName() {
        const {
            className,
            mode
        } = this.props
        let classNameArr = className ?className.split(' '):[]
        classNameArr.push('info-text', 'widget')
        return  classNameArr.join(' ')
    }


    render() {
        const {
            title,
            text,
        } = this.props
        return (
            <div
                className={ this.getClassName() }
                title={ title }
            >
                { text }
            </div>
        )
    }
}

InfoText.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/app/widget/info-text/index.jsx